import angular from "angular";
import { BaseFileUpload } from 'app/common/files.upload';

class UserFileUpload extends BaseFileUpload {

    constructor ($cookies, TokenService, Upload, UserService) {
        super($cookies, TokenService, Upload);
        this.user = UserService.$user;
        this.endpoint = `${UserService.endpoint.getRequestedUrl()}/update`;
    }

    uploadFile (file) {
        if (!file) {
            return ;
        }
        let data = {
            signature: file,
        };
        return super.uploadFile(this.endpoint, data, file.type, 'post');
    }
}


export class ProfileCtrl {
    constructor(UserService, $growl) {
        "ngInject";
        this.$user = UserService.$user;
        this.$growl = $growl;
        this.endpoint = UserService.endpoint;
        this.data = {phone_number: this.$user.phone_number};
    }

    submitChange() {
        let self = this;

        self.loading = true
        this.endpoint.post('update', self.data).then(
            () => {
                self.$growl.success('Phone Number changed!');
                self.errors = {}
            },
            (response) => {
                self.errors = response.data;
            }
        ).finally(() => self.loading = false);
    }

    clean() {
        this.data = {phone_number: this.$user.phone_number};
    }
}


export class ChangePasswordCtrl {
    constructor(UserService, AuthService, $growl) {
        "ngInject";
        this.$user = UserService.$user;
        this.AuthService = AuthService;
        this.$growl = $growl;
        this.loading = false;
        this.data = {
            current_password: '',
            new_password: '',
            re_new_password: '',
        };
    }

    resetInputs () {
        this.data = {
            current_password: '',
            new_password: '',
            re_new_password: '',
        };
    }

    submitPasswordChange () {
        let self = this;

        self.loading = true
        this.AuthService.changePassword(self.data).then(
            () => {
                self.$growl.success('Password changed!');
                self.resetInputs();
                self.errors = {}
            },
            (response) => { self.errors = response.data; }
        ).finally(() => self.loading = false);
    }
}

export class UserNotificationsCtrl {
    constructor(UserService, $growl) {
        "ngInject";
        this.$user = UserService.$user;
        this.endpoint = UserService.endpoint;
        this.$growl = $growl;
        let userNotifications = this.$user.notifications_settings
        this.notifications = {
            ticket_was_mixed_email: userNotifications? userNotifications.ticket_was_mixed_email : false,
            ticket_was_mixed_sms: userNotifications? userNotifications.ticket_was_mixed_sms : false,
            ticket_start_delivery_email: userNotifications? userNotifications.ticket_start_delivery_email : false,
            ticket_start_delivery_sms: userNotifications? userNotifications.ticket_start_delivery_sms : false,
            ticket_finish_delivery_email: userNotifications? userNotifications.ticket_finish_delivery_email : false,
            ticket_finish_delivery_sms: userNotifications? userNotifications.ticket_finish_delivery_sms : false,
            ticket_start_application_email: userNotifications? userNotifications.ticket_start_application_email : false,
            ticket_start_application_sms: userNotifications? userNotifications.ticket_start_application_sms : false,
            ticket_stop_application_email: userNotifications? userNotifications.ticket_stop_application_email : false,
            ticket_stop_application_sms: userNotifications? userNotifications.ticket_stop_application_sms : false,
            ticket_ready_to_bill_email: userNotifications? userNotifications.ticket_ready_to_bill_email : false,
            ticket_ready_to_bill_sms: userNotifications? userNotifications.ticket_ready_to_bill_sms : false,
        };
    }

    submitChange() {
        let self = this;
        this.endpoint.post('notifications', self.notifications).then(
            () => {
                self.$growl.success('Notifications settings updated!');
                self.errors = {}
                self.$user.notifications_settings = self.notifications
            },
            (response) => {
                self.$growl.error('Something went wrong', response.data);
            }
        )
    }
}

export class UploadSignatureCtrl {
    constructor(UserService, $cookies, TokenService, $growl, Upload) {
        "ngInject";
        this.$user = UserService.$user;
        this.$growl = $growl;
        this.endpoint = UserService.endpoint;
        this.fileUpload = new UserFileUpload($cookies, TokenService, Upload, UserService);
    }

    upload (file) {
        let self = this;
        this.fileUpload.uploadFile(file).then((response) => {
            angular.extend(self.$user, response.data);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/account/ctrls.js